import api from './index.js';

api.internals.register(api.modal.ModalSelector.MODAL, api.modal.Modal);
api.internals.register(api.modal.ModalSelector.BODY, api.modal.ModalBody);
api.internals.register(api.modal.ModalSelector.FOOTER, api.modal.ModalFooter);
api.internals.register(api.core.RootSelector.ROOT, api.modal.ModalsGroup);

export default api;
